/**
 * App-wide UI state that several screens open or close: the New dialog and
 * the keyboard-shortcuts dialog. A tiny external store keeps it boring.
 */
import { useSyncExternalStore } from "react";

export type NewDialogView = "choose" | "ai" | "upload";

interface UiState {
  newDialog: { open: boolean; view: NewDialogView };
  shortcutsOpen: boolean;
}

let state: UiState = { newDialog: { open: false, view: "choose" }, shortcutsOpen: false };
const listeners = new Set<() => void>();

function set(next: UiState): void {
  state = next;
  for (const l of listeners) l();
}

export function openNewDialog(view: NewDialogView = "choose"): void {
  set({ ...state, newDialog: { open: true, view } });
}

export function setNewDialogOpen(open: boolean): void {
  set({ ...state, newDialog: { ...state.newDialog, open } });
}

export function setNewDialogView(view: NewDialogView): void {
  set({ ...state, newDialog: { ...state.newDialog, view } });
}

export function setShortcutsOpen(open: boolean): void {
  set({ ...state, shortcutsOpen: open });
}

export function useUiState(): UiState {
  return useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    () => state,
    () => state,
  );
}
